import React from 'react';
import { Node } from '@uncinc/react-drupal-core';

import { Paginate } from '../../../components';

import './style.scss';

const ArticlesAllOverview = ({ onLoadMore, pager, loading, entities, setCurrentPage, ...props }) => {

  return (
    <div className="View ArticlesAllOverview">
      <div className="row no-gutters">
        {entities.map((entity, index) => {
          const id = entity.getIn(['nid', '0', 'value']);
          const uuid = entity.getIn(['uuid', 0, 'value']);
          const langcode = entity.getIn(['langcode', 0, 'value']);
          const className = 'col-12 col-md-4 ArticlesAllOverview__item-wrapper';

          return (
            <div key={`${uuid}:${langcode}`} className={className}>
              <Node
                id={id}
                isActivePath
                entity={entity}
                viewMode="teaser"
              />
            </div>
          );
        })}
      </div>
      <Paginate currentPage={pager.get('current_page')} totalPages={pager.get('total_pages')} setCurrentPage={setCurrentPage} />
    </div>
  );
};

export default ArticlesAllOverview;
